import { Component, OnInit, OnDestroy, ViewChild, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ServerService } from '../../service/server/server.service';
import { MessageService } from '../../service/message/message.service';

@Component({
  selector: 'app-insert-model',
  templateUrl: './insert-model.component.html',
  styleUrls: ['./insert-model.component.scss']
})
export class InsertModelComponent implements OnInit, OnDestroy {
  public user_info: any = JSON.parse(<any>localStorage.getItem('user_info'));
  public lang: any = JSON.parse(<any>localStorage.getItem('lang'));
  public dir: any = JSON.parse(<any>localStorage.getItem('dir'));
  public server: string = this.serverService.get_server();
  public server_main: string = this.serverService.get_server_main();
  public site: string = this.serverService.get_site();
  public user_id: number = this.user_info.user_id;
  public isOnline: any | undefined;
  public loading = false;
  public subscription: Subscription | any;
  public err: string | undefined; public err_validation: boolean = false;
  public err_internet_text: string | undefined; public err_internet_validation: boolean | undefined;
  public device: number | undefined;
  public brand: number | undefined;
  public form1_group: FormGroup | any;
  public model: number | undefined;
  public creator: number | undefined;
  constructor(
    public serverService: ServerService
    , public router: Router
    , public messageService: MessageService
    , public matSnackBar: MatSnackBar
    , public matDialogRef: MatDialogRef<InsertModelComponent>
    , @Inject(MAT_DIALOG_DATA) public dialog_data: any
  ) {
    if (dialog_data) {
      this.device = dialog_data.device;
      this.brand = dialog_data.brand;
      this.creator = dialog_data.creator;
    }
  }//end consructor

  ngOnInit() {
    this.create_form();
  }
  create_form() {
    this.form1_group = new FormGroup({
      'title': new FormControl(null, Validators.required),
      'comment': new FormControl(null),
    })
  }
  insert(): any {
    if (this.messageService.check_internet() == false) {
      this.message(true, this.messageService.internet(), 1, this.messageService.close());
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    if (!this.form1_group.valid) {
      return false;
    }
    if (!this.device || !this.brand) {
      var pe_message = "برای ثبت مدل باید دستگاه و برند مشخص باشد";
      var en_message = "To register the model, the device and brand must be specified";
      this.message(true, this.messageService.message(pe_message), 1, this.messageService.close());
      return false;
    }
    var obj = {
      'address': 1671,
      'user_id': this.user_id, status_id: 1,
      'device': this.device,
      'brand': this.brand,
      'model': this.model,
      'title': this.form1_group.value.title,
      'comment': this.form1_group.value.comment,
      'creator': this.creator
    }
    this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          this.matDialogRef.close({ model: res['result'][0].repairman_model_id, model_title: res['result'][0].repairman_model_title })
          this.message(true, this.messageService.save(), 1, this.messageService.close());
        }//end if
        else if (res['status'] == 4) {
          var pe_message = "این عنوان مدل برای این دستگاه و برند قبلا در سیستم ثبت شده است";
          var en_message = "This model title for this device and brand has already been registered in the system";
          this.message(true, this.messageService.message(pe_message), 1, this.messageService.close());
        }
        else {
          this.message(true, this.messageService.erorr_in_load(), 1, this.messageService.close());
        }
      }
    )
  }
  check_letter(event): any {
    var charCode = (event.which) ? event.which : event.keyCode;
    if ((charCode < 48 && charCode > 57)) {
      event.preventDefault();
      return false;
    } else {

    }
  }
  close() {
    this.matDialogRef.close();
  }
  //**************************************************
  message(validation: boolean, message: string, type: number, action: string) {
    if (type == 1) this.loading = false;
    if (validation == true) {
      this.matSnackBar.open(message, action, { duration: 3000 });
    }//end if
    else {
      //this.matSnackBar.dismiss();
    }
  }//end 
  //*******************************************************************************
  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }//end if
  }//end OnDestroy
}
